@let ranges = listStore.rangesSg();
@let expanded = expandedSg();
@let showExpandButton = showExpandButtonSg();

<div class="atn-ds-date-multi-range-input">
  <div
    [ngClass]="[
      expanded
        ? 'atn-ds-date-multi-range-input__items-expanded'
        : 'atn-ds-date-multi-range-input__items-collapsed',
    ]"
    #containerRef
  >
    @for (range of ranges; track $index) {
      <div
        class="atn-ds-date-multi-range-input__item"
        #selectedItemRef
      >
        {{ range | formattedDateRange }}
      </div>
    } @empty {
      <div class="atn-ds-date-multi-range-input__placeholder">
        Select date ranges...
      </div>
    }
  </div>
  @if (showExpandButton) {
    <div
      class="atn-ds-date-multi-range-input__expander-button"
      (click)="$event.stopPropagation(); toggleExpandButtonClickHandler()"
    >
      {{ expanded ? 'Hide' : 'Show' }}
    </div>
  }
</div>
